import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { applyIamAuthHeaders } from './applyIamAuthHeaders'
import { getEngineApiBaseUrl } from '@/config/engineApiBaseUrl'
import { API_TIMEOUT_MS } from '@/api/timeouts'

const engineClient: AxiosInstance = axios.create({
  baseURL: getEngineApiBaseUrl(),
  timeout: API_TIMEOUT_MS,
  headers: { 'Content-Type': 'application/json', accept: 'application/json' },
  withCredentials: true,
})

engineClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.baseURL = getEngineApiBaseUrl()
  applyIamAuthHeaders(config)
  return config
})

engineClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const data = error.response?.data as Record<string, unknown> | undefined
    const bodyText =
      (typeof data?.message === 'string' && data.message) ||
      (typeof data?.error === 'string' && data.error) ||
      ''
    const statusCode = error.response?.status

    return Promise.reject({
      message: bodyText || error.message || 'Engine request failed',
      statusCode,
      code: typeof data?.error === 'string' ? data.error : undefined,
      details: data?.details,
    })
  }
)

export default engineClient
